import React, { useState } from 'react';
import { Alert, Box, CircularProgress, Grid, Typography } from '@mui/material';
import EditTailoredRegionNameModal from 'src/App/Dashboards/Market/Modals/CustomBoundaryDrawingModal/EditTailoredRegionNameModal';
import { OnboardingModalMobile } from 'src/App/Dashboards/Market/Modals';

const SubmarketToTailoredRegion = ({
  search,
  getTokenThunk,
  setIsTailoredRegionOpen,
  tailoredRegionMarkers,
  getTailoredRegionMarkers,
}) => {
  const predefinedboundaryWKT = search.data.polygon || search.data.polygon_multi;

  const AlertTextComponent = (
    <Alert severity="warning">
      We are moving your submarkets to custom markets. They should be available by 17th May, 2025.
      Till then please use custom markets. Sorry for the inconvenience
    </Alert>
  );

  return (
    <>
    <OnboardingModalMobile
      getTokenThunk={getTokenThunk}
      setIsTailoredRegionOpen={setIsTailoredRegionOpen}
      tailoredRegionMarkers={tailoredRegionMarkers}
      getTailoredRegionMarkers={getTailoredRegionMarkers}
      AlertTextComponent={AlertTextComponent}
      predefinedboundaryWKT={predefinedboundaryWKT}
    />
    </>
  );
};

export default SubmarketToTailoredRegion;
